import api from "@/lib/api";

const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

// Download the full workspace backup as a single dated .xlsx file.
export async function downloadBackup() {
  const res = await api.get("/oihr/backup/excel", { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const fname = m ? m[1] : `DVEPL-Backup-${new Date().toISOString().slice(0, 10)}.xlsx`;
  const url = window.URL.createObjectURL(new Blob([res.data], { type: XLSX_MIME }));
  const a = document.createElement("a");
  a.href = url;
  a.download = fname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 10000);
  return fname;
}
